<router-outlet></router-outlet>
<projul-lightbox ></projul-lightbox>